import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import type { NavItem } from "../../nav";
import { Icon } from "../../ui";
import "./social.css";

const SocialPage = lazy(() => import("./overview").then((m) => ({ default: m.SocialPage })));
const PlannerPage = lazy(() => import("./planner").then((m) => ({ default: m.PlannerPage })));
const PostEditorPage = lazy(() => import("./post").then((m) => ({ default: m.PostEditorPage })));
const PublishedPage = lazy(() => import("./published").then((m) => ({ default: m.PublishedPage })));
const CommentsPage = lazy(() => import("./inbox").then((m) => ({ default: m.CommentsPage })));
const MessagesPage = lazy(() => import("./inbox").then((m) => ({ default: m.MessagesPage })));
const InsightsPage = lazy(() => import("./insights").then((m) => ({ default: m.InsightsPage })));
const ChannelsPage = lazy(() => import("./channels").then((m) => ({ default: m.ChannelsPage })));
const LinksPage = lazy(() => import("./links").then((m) => ({ default: m.LinksPage })));
const WinnersPage = lazy(() => import("./winners").then((m) => ({ default: m.WinnersPage })));
const SocialSettingsSection = lazy(() => import("./settings").then((m) => ({ default: m.SocialSettingsSection })));

/**
 * Social: the business's social media desk. Plan posts on a calendar, write them (with AI), get them approved, post
 * them, answer comments and messages, and see what worked; its link in bio page and the giveaway winners to message.
 */

export const routes: SolutionRoute[] = [
  { solution: "social", path: "social", element: <SocialPage /> },
  { solution: "social", path: "social/planner", element: <PlannerPage /> },
  { solution: "social", path: "social/new", element: <PostEditorPage /> },
  { solution: "social", path: "social/posts/:id", element: <PostEditorPage /> },
  { solution: "social", path: "social/published", element: <PublishedPage /> },
  { solution: "social", path: "social/comments", element: <CommentsPage /> },
  { solution: "social", path: "social/messages", element: <MessagesPage /> },
  { solution: "social", path: "social/insights", element: <InsightsPage /> },
  { solution: "social", path: "social/channels", element: <ChannelsPage /> },
  { solution: "social", path: "social/links", element: <LinksPage /> },
  { solution: "social", path: "social/winners", element: <WinnersPage /> },
];

export const settings: SolutionSettings[] = [{ solution: "social", key: "social", label: "Social", icon: Icon.megaphone, need: "social.view", Component: SocialSettingsSection }];

/** The sidebar entry (already in nav.ts; kept here so the paths stay together). */
export const nav: NavItem = {
  to: "/social", label: "Social", icon: Icon.megaphone, solution: "social", need: "social.view",
  subs: [
    { to: "/social/planner", label: "Planner" },
    { to: "/social/published", label: "Published" },
    { to: "/social/comments", label: "Comments" },
    { to: "/social/messages", label: "Messages" },
    { to: "/social/insights", label: "Insights" },
    { to: "/social/channels", label: "Channels" },
    { to: "/social/links", label: "Profile links" },
    { to: "/social/winners", label: "Message winners" },
  ],
};
